import { useFormik, type FormikErrors } from 'formik';
import React from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { TypeColumnEditModal } from './TypeColumnEditModal';
import { type TypeFormValues } from './form';
import {
  type RowDisplayOption,
  type ColumnDisplayOptions,
} from '../../../export';

type Props = {
  isOpen: boolean;
  title: string;
  general: string;
  analytical: string;
  description: string;
  isDeletable: boolean;
  onRemoveColumn: () => void;
  onClose: () => void;
  onSaveColumn: (values: TypeFormValues) => void;
  rowDisplayOptions?: RowDisplayOption[];
  displayOptions?: ColumnDisplayOptions;
  maxLength?: string;
};

export const TypeColumnEditModalContainer = ({
  title,
  onSaveColumn,
  general,
  analytical,
  displayOptions,
  maxLength,
  ...rest
}: Props) => {
  const { t } = useTranslation('global');

  const formikProps = useFormik<TypeFormValues>({
    initialValues: {
      title,
      general,
      analytical,
      displayOptions,
      maxLength,
    },
    validate: (values) => {
      const errors: FormikErrors<TypeFormValues> = {};

      if (!values.title.trim()) {
        errors.title = t('exports.emptyColumnTitleError');
      }

      if (!values.general?.trim()) {
        errors.general = t('bookkeep.settings.export.typeOptions.emptyError');
      }

      if (!values.analytical?.trim()) {
        errors.analytical = t(
          'bookkeep.settings.export.typeOptions.emptyError',
        );
      }

      return errors;
    },
    onSubmit: (values) => {
      onSaveColumn({
        title: values.title,
        general: values.general,
        analytical: values.analytical,
        displayOptions: values.displayOptions,
        maxLength: values.maxLength,
      });
    },
  });

  return <TypeColumnEditModal title={title} {...rest} {...formikProps} />;
};
